function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.41421 8.58579L8.58579 1.41421C9.36683 0.633165 10.6332 0.633163 11.4142 1.41421L18.5858 8.58579C19.3668 9.36683 19.3668 10.6332 18.5858 11.4142L11.4142 18.5858C10.6332 19.3668 9.36684 19.3668 8.58579 18.5858L1.41421 11.4142C0.633165 10.6332 0.633163 9.36684 1.41421 8.58579Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 14H7V8H12V6L15 9L12 12V10H9V14Z",
  fill: "white"
});

var SvgDirectionIcon = function SvgDirectionIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDirectionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/direction-icon.954b1c4b.svg";
export { ForwardRef as ReactComponent };